(function (window) {
  'use strict';

  // Contains functionality for hiding/showing other elements on the page as
  // the collections are switched. accordion-tabs.js handles the basic
  // accordion/tab behavior.

  function initInstance(instance) {
    const tabs = instance.querySelectorAll('.js-accordion-tabs-tab');
    const accordionControls = instance.querySelectorAll('.js-accordion-tabs-accordion-control');
    let activeCollection;

    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', handleTab);

      if (tabs[i].getAttribute('aria-expanded') === 'true') {
        activeCollection = tabs[i].getAttribute('data-tab');
      }
    }

    for (let i = 0; i < accordionControls.length; i++) {
      accordionControls[i].addEventListener('click', handleAccordionControl);
    }

    toggleCollectionItemVisibility(activeCollection);
  }

  function toggleCollectionItemVisibility(activeCollection) {
    const collectionItems = document.querySelectorAll('[data-lens-collection]');

    for (let i = 0; i < collectionItems.length; i++) {
      if (collectionItems[i].getAttribute('data-lens-collection') == activeCollection) {
        collectionItems[i].classList.remove('js-hidden');
        triggerNativeEvent(window, 'resize');
      }
      else {
        collectionItems[i].classList.add('js-hidden');
      }
    }
  }

  function handleTab(e) {
    const tab = e.target.closest('.js-accordion-tabs-tab');
    const collectionId = tab.getAttribute('data-tab');

    toggleCollectionItemVisibility(collectionId);
  }

  function handleAccordionControl(e) {
    const contentWrapper = e.target.parentNode.querySelector('.js-accordion-tabs-content');
    const collectionId = contentWrapper.getAttribute('data-tab');

    toggleCollectionItemVisibility(collectionId);
  }

  function init() {
    const instances = document.querySelectorAll('.js-lens-collections');

    for (let i = 0; i < instances.length; i++) {
      if (!instances[i].classList.contains('js-lens-collections-init')) {
        initInstance(instances[i]);

        instances[i].classList.add('js-lens-collections-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
